/* eslint-disable consistent-return */
import apiService from 'src/enviroment';

const getLaunch = async () => {
  const response = await apiService.get('/reportes/maestros/lanzamientos/');
  try {
    if (response.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const getLaunchHigh = async () => {
  const response = await apiService.get(
    '/reportes/maestros/lanzamientosaltagamadeportivas/',
  );
  try {
    if (response.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const updateLauchHigh = async (params) => {
  const body = {
    linea: params.LINEA,
    lanzamiento: params.tableData.checked,
  };
  const response = await apiService.put(
    '/reportes/maestros/lanzamientosaltagamadeportivas/',
    body,
  );
  try {
    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const updateLauch = async (params) => {
  const body = {
    linea: params.LINEA,
    lanzamiento: params.tableData.checked,
  };
  const response = await apiService.put('/reportes/maestros/lanzamientos/', body);
  try {
    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('else');
  }
};

const launchService = {
  getLaunch, updateLauch, getLaunchHigh, updateLauchHigh,
};

export default launchService;
